// @ts-ignore
import ArticleDetailPageLayout from '@sprinx/cvo-eshop-ui-common/pages/ArticleDetailPage/ArticleDetailPageLayout';
import React from 'react';
import { AfterPage, AfterPageProps } from '../../@sprinx/after-razzle';
import articleData from '../../api/articleData';
import commonData from '../../api/commonData';
import AppLayout from '../../layouts/AppLayout';
import { ArticlePageData } from '../../types/ArticlePageData';
import ErrorPage from '../ErrorPage';
import NotFoundPage from '../NotFoundPage';

export interface ArticleDetailPageProps extends AfterPageProps<ArticleDetailPageRouteParams> {
  data?: ArticlePageData;
}

interface ArticleDetailPageRouteParams {
  path: string;
}

const ArticleDetailPage: AfterPage<ArticleDetailPageRouteParams, ArticleDetailPageProps> = ({ data, error }) => {
  if (error) return <ErrorPage error={error} />;
  if (!data || !data.article) return <NotFoundPage />;

  const { article, layout } = data;

  return (
    <AppLayout headerProps={layout.header} footerProps={layout.footer}>
      {/* @ts-ignore */}
      <ArticleDetailPageLayout article={article} />
    </AppLayout>
  );
};

ArticleDetailPage.getInitialProps = async ({ match }) =>
  /* {
    match, initialAppProps
  },*/
  {
    const layout = await commonData.get();
    const path = match.params.path;
    const article = path ? await articleData.get({ href: `/${path}` }) : { body: 'DEMO', title: 'DEMO', href: '' };
    const data: ArticlePageData = {
      article,
      title: article.title,
      layout,
    };

    return {
      data,
    };
  };

export default ArticleDetailPage;
